import {Fragment, useEffect, useMemo} from 'react';

import {prospectApi} from 'api';
import {APP_LANDING_UPGRADE_URL} from 'constants/app';
import {useApiData, useObservable} from 'hooks';
import {accountPlanStore} from 'services';
import {AccountPlanId} from 'types';
import {billingPlatformUtils, userAuthUtils} from 'utils';

import {FreePlanBanner} from './FreePlanBanner';

type Props = {
    className?: string;
}

export const AccountPlanBanner: React.FC<Props> = ({className}) => {
    const {planId, hasBillingPlatformProfile} = useObservable(accountPlanStore);
    const hasBillingPagePermissions = useMemo(() => userAuthUtils.getUserPermissions()?.account?.billing?.enabled, []);

    const {send: getUpgradeToken, data} = useApiData(prospectApi.getUpgradeToken);
    const upgradeUrl = useMemo(() => data?.token ? `${APP_LANDING_UPGRADE_URL}?data=${data.token}` : null, [data]);
    const upgradeIsAvailable = useMemo(() => billingPlatformUtils.isUpgradablePlan(planId), [planId]);

    useEffect(() => {
        if (hasBillingPlatformProfile && upgradeIsAvailable && hasBillingPagePermissions) {
            getUpgradeToken();
        }
    }, [hasBillingPlatformProfile, upgradeIsAvailable, hasBillingPagePermissions, getUpgradeToken]);

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <Fragment>
            {/* TODO: add banner for other plans */}
            {planId === AccountPlanId.Free && <FreePlanBanner upgradeUrl={upgradeUrl} className={className} />}
        </Fragment>
    );
};
